import { apiService } from "../services/base-api-service";
import { endPoints, getEmailServiceEndPoint } from "../services/api-constants";

class EmailService {
  EmailService(url) {
    return getEmailServiceEndPoint(url);
  }
  VerifyOtp(userguid, otp) {
    const emailEndPoint = this.EmailService(
      `${endPoints.emailservice.VERIFY_OTP.replace(":userguid", userguid).replace(":token", otp)}`
    );
    return apiService.post(emailEndPoint, userguid);
  }
}

export default new EmailService();
